<div class="container">
  <div class="register-card">
    <h2 class="register-card-title">Ainda não é assinante?</h2>
    <p class="register-card-content">Cadastre-se gratuitamente e descubra como vários de profissionais da área da saúde estão aprimorando seus estudos através do método inovador SimSave.</p>
    
    <a mat-raised-button class="register-card-btn" (click)="goToLogin()">Cadastre-se</a>
  </div>
</div>

